/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Revokeaccesswarning3Inputs */

const en_usermanagement_permissions_revokeaccesswarning3 = /** @type {(inputs: Usermanagement_Permissions_Revokeaccesswarning3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User will no longer have access to this fund and it will be removed from their account`)
};

/**
* | output |
* | --- |
* | "User will no longer have access to this fund and it will be removed from their account" |
*
* @param {Usermanagement_Permissions_Revokeaccesswarning3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_revokeaccesswarning3 = /** @type {((inputs?: Usermanagement_Permissions_Revokeaccesswarning3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Revokeaccesswarning3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_revokeaccesswarning3(inputs)
});
export { usermanagement_permissions_revokeaccesswarning3 as "userManagement_permissions_revokeAccessWarning" }